export default {
  data () {
    return {
      showThumbnail: false
    }
  },
  methods: {
    selectedAction (actionType) {
      let variant = 'light'
      switch (actionType) {
        case 'select':
          if (this.select && this.draw === false) { variant = 'primary' }
          break
        case 'draw':
          if (this.draw && this.select === false) { variant = 'primary' }
          break
        case 'edit':
          if (this.focusedElement) { variant = 'light' }
          break
        case 'delete':
          if (this.canDelete) { variant = 'danger' }
          break
        case 'save':
          if (this.enableSave()) { variant = 'success' }
          break
        default:
          variant = 'light'
      }
      return variant
    },
    toggleThumbnail () {
      this.showThumbnail = !this.showThumbnail
    },
    thumbnailSelected (id) {
      return Number(id) === Number(this.id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/tools.js